import React from "react";
import { JackpotIznos } from "./JackpotIznos.jsx";
import RiveComponent from "../../Components/Shared/RiveComponent";

const fallbackImageThumb = "https://cdn.supersport.hr/casino/GameImages/Default/SC_default_thumbnail.jpg";
const fallbackImageIcon = "https://cdn.supersport.hr/casino/GameImages/Default/SC_default_icon.jpg";

export function GameImage({ igra, brands, iconImage, goLazyImage, bigPicture, isRive, isVerticalImage = false }) {

    const brand = brands?.[igra?.bID];

    // Build the shared base URL used by static and Rive game thumbnails
    const imageBaseUrl = casino.config.gameImagesUrl + brand.nameNormalizirano + "/" + casino.utils.normalizeString(igra.n);

    // Use WebP when supported, otherwise fall back to jpeg
    const imageExtension = casino.config.canIUseWebP ? ".webp" : ".jpeg";

    // Append the GUI version
    const cacheQuery = `?c=${casino.config.guiCacheVerzija}`;

    let imgBig = imageBaseUrl + imageExtension + cacheQuery;

    let imgSmall = imageBaseUrl + "-m" + imageExtension + cacheQuery;

    const appIconSmall = imageBaseUrl + "-xicon-m" + imageExtension + cacheQuery;

    // Rive files follow the same provider/game naming convention as static images
    const riveSrc = imageBaseUrl + ".riv";

    // Vertical cards always use their dedicated jpeg thumbnail
    if (isVerticalImage) {
        const verticalImageUrl = imageBaseUrl + "-xvertical.jpeg" + cacheQuery;

        imgBig = verticalImageUrl;
        imgSmall = verticalImageUrl;
    }

    // The "o" property marks a game as being under maintenance
    const isUnderMaintenance = igra?.p?.includes("o");

    // Adds ribbon styling for games that belong to the Golden Coins category
    const hasGoldenCoins = igra?.p?.includes("gcl");

    // Maintenance cards always show a static image, even when the game normally uses Rive
    const shouldRenderStaticImage = isUnderMaintenance || !isRive;

    // Rive is shown only for active games marked as Rive-enabled
    const shouldRenderRive = !isUnderMaintenance && isRive && riveSrc;

    // Builds a CSS background-image value with de-duplicated layers, ending in a global fallback
    const buildBackgroundImage = (urls, globalFallback) => {
        const layers = [...urls, globalFallback]
            .filter(Boolean)
            .filter((url, index, arr) => arr.indexOf(url) === index);

        return layers.map(url => `url("${url}")`).join(", ");
    };

    // Select the appropriate static thumbnail layout for icons, large cards, or standard cards
    const renderStaticImage = () => {
        if (iconImage) {
            return (
                <div>
                    <div
                        data-lazyid={igra.s}
                        className={`game-img game-img-icon${goLazyImage ? " lazy" : ""}`}
                        style={{ backgroundImage: buildBackgroundImage([appIconSmall, imgSmall], fallbackImageIcon) }}
                    />
                </div>
            );
        }

        if (bigPicture === "true") {
            return (
                <div
                    data-lazyid={igra.s}
                    className="game-img"
                    style={{ backgroundImage: buildBackgroundImage([imgBig], fallbackImageThumb) }}
                />
            );
        }

        return (
            <div>
                <div
                    data-lazyid={igra.s}
                    className={`game-img${goLazyImage ? " lazy" : ""}`}
                    style={{ backgroundImage: buildBackgroundImage([imgSmall], fallbackImageThumb) }}
                />
            </div>
        );
    };

    return (
        <div className="relative">
            <div className={`relative ${hasGoldenCoins ? "has-golden-coins" : ""}`}>
                {isUnderMaintenance && (
                    <div className={`maintenance-overlay ${iconImage ? "icon-image" : ""}`}>
                        <div className="icon" />
                        <div className="info">
                            Održavanje u tijeku
                        </div>
                    </div>
                )}

                {shouldRenderStaticImage && renderStaticImage()}

                {shouldRenderRive && (
                    <div className="rive-container">
                        <div className="rive-offset">
                            <RiveComponent
                                lazyLoad
                                cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                src={riveSrc}
                                stateMachines="State Machine 1"
                                artboard="Artboard"
                                useOffscreenRenderer
                                width="664"
                                height="460"
                                playRequest
                                disablePlayOutsideViewport={{
                                    rootMargin: "-50px 0px 0px 0px"
                                }}
                            />
                        </div>
                    </div>
                )}

                {igra?.p?.includes("n") &&
                    !igra.p.includes("ex") && (
                        <span className="novo-badge" />
                    )}

                {!iconImage &&
                    igra?.p?.includes("daw") && (
                        <span className="drops-n-wins" />
                    )}

                {!iconImage &&
                    igra?.p?.includes("cc") && (
                        <span className="egt-clover-chance" />
                    )}

                {!iconImage &&
                    igra?.p?.includes("bl") && (
                        <span className="egt-bell-link" />
                    )}

                {!iconImage &&
                    igra?.p?.includes("gak") && (
                        <span className="gods-and-kings" />
                    )}

                {!iconImage &&
                    igra?.p?.includes("gcl") && (
                        <span className="golden-coins-link" />
                    )}

                {igra?.p?.includes("md") && (
                    <span className="mystery-drop" />
                )}

                {igra?.p?.includes("jr") && (
                    <span className="jackpot-rain-ribbon" />
                )}

                {igra?.p?.includes("sg") && (
                    <span className="spin-gifts-badge" />
                )}

                {igra?.p?.includes("pp") && (
                    <span className="pateplay-badge" />
                )}

                {igra?.p?.includes("ex") && (
                    <span className="exclusive-badge" />
                )}

                {igra?.p?.includes("br") && (
                    <span className="barlink-badge" />
                )}

                {igra?.jpName && (
                    <span
                        className={`jackpotName-badge ${igra.jpName
                            .toString()
                            .toLowerCase()}`}
                    >
                        {igra.jpName}
                    </span>
                )}
            </div>

            {igra?.jpIznos && (
                <div className="margin-top-xsmall margin-bottom-xsmall">
                    <JackpotIznos iznos={igra.jpIznos} />
                </div>
            )}
        </div>
    );
}